import React from 'react'
import { useTranslation } from 'react-i18next'
import { capitalizeAll } from '@btime/helpers'
import { useLoggedUser } from '@btime/react-session'

import SideMenuPageTemplate from '../../components/templates/v2/SideMenuTemplate'
import Text, { Title } from '../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import Separator from '../../packages/kiti/components/helpers/Separator'
import { UserAvatar } from '../../components/presentation/Avatar'
import ProcessesSection from './ProcessesSection'

const ProcessesPage = () => {
  const user = useLoggedUser()
  const { t } = useTranslation('processes')

  return (
    <SideMenuPageTemplate bgColor="white">
      <Separator weight={6}>
        <Grid justify="space-between" align="center" gap={3}>
          <Col flex={1}>
            <Title color="dark2" size="h2" bold noMargin>
              {t('processes.welcome', { name: capitalizeAll(user.name) })}
            </Title>
            <Text color="dark2">{t('processes.welcomeMessage')}</Text>
          </Col>
          <Col width={2}>
            <UserAvatar user={user} />
          </Col>
        </Grid>
        <Separator weight={9} />
        <Title color="dark2" size="h3" bold noMargin>
          {t('processes.title')}
        </Title>
        <Separator weight={4} />
        <ProcessesSection />
      </Separator>
    </SideMenuPageTemplate>
  )
}

export default ProcessesPage
